/**
 * Created by andrey on 29.05.17.
 */

const MarksBlock = ElementsChooser.extend({
    ctor: function () {
        const table = {};

        const markView = new MarkView({ mark: new Mark() });
        table["!"] = this.createElementView(markView);

        this._super({
            type: "mark",
            table 
        });

        this.displayMarksAmount(0);
    },

    createElementView: function (markView) {
        const view = new cc.Node();
        view.element = markView;
        view.addChild(markView);
        view.setContentSize2(markView.getContentSize());
        view.setAnchorPoint(0.5, 0.5);
        markView.setPosition(view.width / 2, view.height / 2);
        view.setPosition(view.width / 2, view.height / 2);

        return view;
    },

    displayMarksAmount: function (count) {
        if (this.title) {
            this.title.removeFromParent(true);
        }

        // eslint-disable-next-line no-restricted-syntax
        const title = cleverapps.UI.generateTTFText(`Marks:\n${(count === undefined) ? 0 : count.toString()} now`, cleverapps.styles.FONTS.EDITOR_TEXT);
        title.setAnchorPoint(0, 0.5);
        title.setPosition(cleverapps.styles.MarksBlockView.title.x, 0);
        this.addChild(title);

        this.title = title;
    }
});

cleverapps.styles.MarksBlockView = {
    title: {
        x: 100
    }
};